import type {Level} from 'shells/status-badge/status-badge';

import type {InvoiceStatus} from 'nutshell-graphql-types';

export const getInvoiceStatusBadge = (
    status: InvoiceStatus
):
    | {
          level: Level;
          text: string;
      }
    | null
    | undefined => {
    switch (status) {
        case 'SCHEDULED':
            return {level: 'info', text: 'Scheduled'};
        case 'PAID':
            return {level: 'success', text: 'Paid'};
        case 'NOT_PAID':
            return {level: 'alert', text: 'Not paid'};
        case 'PAYMENT_FAILED':
            return {level: 'alert', text: 'Payment failed'};
        case 'LATE':
            return {level: 'warning', text: 'Late'};
        case 'REFUND':
            return {level: 'success', text: 'Refunded'};
        default:
            return null;
    }
};
